import { Component } from '@angular/core';

import { GenericField, IGenericField } from '../generic-field';

/**
 * Text-field
 * Generate a simple text field
 * @extends GenericField
 * @deprecated
 */
@Component({

    selector: 'textarea-field',
    templateUrl: './textarea-field.component.html',
    styleUrls: ['./textarea-field.component.scss']
})
export class TextareaFieldComponent extends GenericField implements IGenericField {
    constructor() {
        super();
    }
}
